module.exports = __webpack_public_path__ + "static/img/icon14.7c86ab07.png";